import React from "react";
import { FaDog, FaPaw, FaShieldAlt, FaCheckCircle } from "react-icons/fa";

const services = [
  {
    icon: <FaPaw className="text-orange-500 text-5xl" />,
    title: "Pet Grooming Service",
    description: "Book In-Home Grooming Session",
    link: "Find out more about Pet Grooming",
  },
  {
    icon: <FaDog className="text-orange-500 text-5xl" />,
    title: "Cat Boarding & Dog Boarding Service",
    description: "Book Pet Boarding & Pet Sitting Service",
    link: "Find out more about Pet Boarding",
  },
  {
    icon: <FaPaw className="text-orange-500 text-5xl" />,
    title: "Dog Walking Service",
    description: "Book Personalised Dog Walkers Near You",
    link: "Find out more about Dog Walking",
  },
  {
    icon: <FaShieldAlt className="text-orange-500 text-5xl" />,
    title: "Vet on call & at-home",
    description: "Book Expert Veterinary Care Service",
    link: "Find out more about Vet on call",
  },
];

const benefits = [
  {
    icon: <FaCheckCircle className="text-green-500 text-3xl" />,
    description: "All service providers undergo a basic background check.",
  },
  {
    icon: <FaCheckCircle className="text-green-500 text-3xl" />,
    description:
      "All service providers offer a comprehensive profile including personal details.",
  },
  {
    icon: <FaCheckCircle className="text-green-500 text-3xl" />,
    description: "All service providers are vetted and approved by our team of pet care specialists.",
  },
];

const ServicesSection = () => {
  return (
    <div className="bg-gray-50 py-16 px-6">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-3xl font-bold text-center text-gray-800 mb-12">
          Services for Every Pet at Adopt a Pet
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          {services.map((service, index) => (
            <div
              key={index}
              className="flex flex-col items-center bg-white p-6 rounded-lg shadow-lg"
            >
              <div>{service.icon}</div>
              <h3 className="text-xl font-semibold text-gray-800 mt-4">
                {service.title}
              </h3>
              <p className="text-gray-600 mt-2">{service.description}</p>
              <a
                href="#"
                className="text-orange-500 mt-4 hover:underline font-medium"
              >
                {service.link} →
              </a>
            </div>
          ))}
        </div>

        <div className="bg-white p-6 rounded-lg shadow-lg">
          <div className="flex flex-col lg:flex-row items-start lg:items-center gap-8">
            <FaShieldAlt className="text-orange-500 text-6xl" />
            <div>
              <h3 className="text-2xl font-bold text-gray-800">
                98.7% of reviews are 5 star
              </h3>
              <p className="text-gray-600 mt-2">
                All services booked on ThePetNest are backed by:
              </p>
              <ul className="mt-4 space-y-4">
                {benefits.map((benefit, index) => (
                  <li key={index} className="flex items-start gap-4">
                    <div>{benefit.icon}</div>
                    <p className="text-gray-600">{benefit.description}</p>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServicesSection;
